import script from "./AnimationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationsView.vue?vue&type=script&setup=true&lang=js"

import "./AnimationsView.vue?vue&type=style&index=0&id=2c27bb7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c27bb7c"]])

export default __exports__